
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11582',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11582",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "dashboard-client-types": "static-1.233",
  "data-fetching-client": "static-1.9487",
  "foundations-components": "static-1.7538",
  "foundations-components-legacy": "static-1.563",
  "foundations-theming": "static-1.4220",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7814",
  "hub-http-shared-msw-handlers": "static-1.9494",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11241",
  "I18n": "static-7.1572",
  "jasmine-runner": "static-1.6281",
  "marketplace-storefront-base": "static-1.11642",
  "quartz": "static-1.6747",
  "react-dlb": "static-1.72",
  "react-rhumb": "static-1.16459",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2670",
  "reporting-testing-lib": "static-1.8493",
  "settings-ui-lib": "static-1.12331",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6747",
  "ui-addon-i18n": "static-1.10948",
  "ui-addon-react-router-dom": "static-1.9355",
  "unified-auth": "static-1.225",
  "unified-auth-core-lib": "static-1.506",
  "usage-tracker": "static-1.7143",
  "usage-tracker-core": "static-1.6993",
  "customer-data-property-utils": "static-1.7886",
  "history": "static-4.47",
  "hub-http": "static-1.6029",
  "integrations-lib": "static-1.15443",
  "marketplace-ui-common": "static-1.18978",
  "property-management-iframe": "static-1.12379",
  "quartz-config": "static-1.525",
  "quartz-core": "static-1.5966",
  "quartz-routing": "static-1.177",
  "quick-fetch": "static-1.3743",
  "react": "static-7.179",
  "rpc-client-utils": "static-1.4443",
  "ts-schema": "static-1.3912",
  "ui-universal-auth": "static-1.8711",
  "UIComponents": "static-3.8188",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3237",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3024",
  "quartz-webpack": "static-1.2971",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3807",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4645",
  "foundations-theming-specialty": "static-1.1936",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9236",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5181",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1226",
  "ui-fonts": "static-1.503",
  "ui-images": "static-2.1094",
  "bend-plugin-foundations-theming": "static-1.2703",
  "foundations-theming-base": "static-1.3205",
  "stylex": "static-1.27",
  "HeadJS": "static-2.711",
  "hs-test-utils-bend-plugin": "static-1.2925",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4135",
  "ai-components-ui-library": "static-1.8367",
  "ai-rendering-library": "static-1.9331",
  "chirp-fetch": "static-1.1691",
  "connections-embed-lib": "static-1.645",
  "copilot-toolkit": "static-1.10554",
  "laboratory-lib": "static-3.6969",
  "marketplace-embed": "static-1.21509",
  "marketplace-ui-details": "static-1.8874",
  "marketplace-ui-reviews": "static-1.18934",
  "marketplace-ui-tracking": "static-1.13149",
  "sanitize-text": "static-1.7949",
  "ui-addon-video-player": "static-1.8505",
  "usage-tracker-multi": "static-1.5557",
  "usage-tracker-session-replay": "static-1.4829",
  "wootric-nps": "static-1.6792",
  "apollo-link-hub-http": "static-2.4458",
  "immer": "static-1.33",
  "immerable": "static-1.3963",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66560",
  "cssUtils": "static-1.734",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11549",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10018",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10180",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7133",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17511",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4330",
  "foundations-components-test-utils": "static-1.5021",
  "quartz-i18n": "static-1.422",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3539",
  "customer-data-objects": "static-1.7458",
  "property-translator": "static-1.5221",
  "frontend-preferences-client": "static-1.7733",
  "hs-promise-utils": "static-1.5402",
  "hubspot-apollo-client": "static-1.4690",
  "integrations-error-boundary-lib": "static-1.12858",
  "integrations-tracking-lib": "static-1.5397",
  "native-integrations-shared-strings": "static-1.7597",
  "reselect": "static-2.16",
  "sanitize": "static-1.4283",
  "superstore": "static-1.4579",
  "ui-shepherd-react": "static-3.9955",
  "ai-settings-ui-library": "static-1.7466",
  "hub-http-janus": "static-1.796",
  "hubspotter-http": "static-1.4486",
  "immutable-less": "static-1.4463",
  "marketplace-ui-client-types": "static-1.16385",
  "nav-meta": "static-1.28931",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10045",
  "ui-addon-upgrades": "static-9.17671",
  "inbound-db-properties-service-client": "static-1.3683",
  "property-management-common": "static-1.4666",
  "ui-addon-iframeable": "static-1.8853",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.484",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.422",
  "quartz-head": "static-1.412",
  "quartz-test": "static-1.422",
  "quartz-tracking": "static-1.126",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2956",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20355",
  "ContentUtils": "static-1.67646",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2295",
  "customer-data-filters-ui": "static-1.38936",
  "customer-data-objects-ui-components": "static-1.12816",
  "customer-data-reference-ui-components": "static-1.12954",
  "embedded-academy-lib": "static-1.13573",
  "ExportDialog": "static-6.10195",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40678",
  "reporting-snowflake": "static-1.55178",
  "reporting-ui-components": "static-2.63831",
  "reporting-visualizations": "static-1.58636",
  "ui-addon-teams": "static-1.21254",
  "magpie-lib": "static-1.5402",
  "magpie-types": "static-1.4862",
  "simple-logging-lib": "static-1.2859",
  "navigation-components": "static-1.17294",
  "ai-studio-lib": "static-1.11024",
  "developer-experience-shared-components": "static-1.10287",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7798",
  "ui-tool-access": "static-1.9953",
  "usage-based-billing-components-lib": "static-1.8023",
  "usage-tracker-anonymous": "static-1.5560",
  "usage-tracker-public": "static-1.6954",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3425",
  "persist-promise": "static-1.3517",
  "reference-resolvers": "static-1.7969",
  "ui-extensibility-client-types": "static-1.3753",
  "hubspot-apollo-cache": "static-1.149",
  "universal-page-editor-lib": "static-1.2808",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2210",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4878",
  "purchase-motions-components": "static-1.5494",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1360",
  "crm-component-utils": "static-1.38503",
  "crm-properties-common-lib": "static-1.5681",
  "framework-data-schema-resolvers": "static-1.6682",
  "reference-resolvers-lite": "static-1.7903",
  "navigation-messaging": "static-1.6621",
  "hubspotter-http-shared-msw-handlers": "static-1.9492",
  "cms-field-types": "static-1.4615",
  "content-icons-ui": "static-1.2156",
  "conversations-skeleton-state": "static-1.7056",
  "crm-message-bus": "static-1.42391",
  "customer-data-filters-ui-msw-helpers": "static-1.21371",
  "customer-data-ui-utilities": "static-1.9632",
  "FormUrlGenerator": "static-2.4538",
  "framework-builder-read-service-client": "static-1.3841",
  "framework-data-schema-quick-fetch": "static-1.6587",
  "multi-account-reference-resolvers": "static-1.782",
  "onboarding-tours": "static-1.16273",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13076",
  "academy-common-lib": "static-1.13033",
  "content-assistance-lib": "static-1.7460",
  "dashboard-lib": "static-1.80661",
  "file-manager-components": "static-1.22913",
  "getting-started-shared-tasks": "static-1.17909",
  "hubspot-prosemirror": "static-1.17628",
  "hubspot-prosemirror-plugins": "static-1.17620",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19482",
  "share-with-third-party-component-lib": "static-1.8500",
  "ui-addon-draggable": "static-3.4574",
  "ui-asset-management-lib": "static-1.10719",
  "ui-business-units-lib": "static-1.8837",
  "user-context": "static-1.4908",
  "growth-payments-core": "static-1.24752",
  "reporting-plugins": "static-1.9994",
  "reporting-reports": "static-1.66238",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.534",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28869",
  "react-codemirror": "static-1.10435",
  "apps-service-types": "static-1.3686",
  "oauth-service-types": "static-1.4051",
  "onboarding-scopes": "static-1.6272",
  "onboarding-tours-client": "static-1.4487",
  "platform-infra-nav-components": "static-1.7500",
  "subscription-experience-data-types": "static-1.14597",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8588",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4322",
  "nav-client-types": "static-1.2166",
  "purchase-motions-api": "static-1.5497",
  "signup-constants": "static-1.18423",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3723",
  "card-properties-lib": "static-1.43545",
  "crm-actions": "static-1.6110",
  "crm-cards-data": "static-1.1227",
  "crm-cards-sdk": "static-1.42946",
  "customer-data-properties": "static-1.50822",
  "customer-data-properties-shared-msw-handlers": "static-1.8821",
  "customer-data-tracking": "static-1.6691",
  "conditional-properties-service-client": "static-1.3631",
  "crm-pipelines-api-client-types": "static-1.3972",
  "multi-currency-client-types": "static-1.3525",
  "external-options-client-types": "static-1.3992",
  "react-dnd-compat": "static-1.4429",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5166",
  "growth-onboarding-confetti": "static-1.2880",
  "growth-onboarding-next-action-utils": "static-1.1312",
  "onboarding-tours-utils": "static-1.339",
  "ui-shepherd-tracker": "static-1.7336",
  "academy-service-client": "static-1.3489",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27966",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8193",
  "video-components-external": "static-1.10592",
  "video-data-lib": "static-1.34250",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8377",
  "payment-link-components": "static-1.22963",
  "ui-addon-emoji-picker": "static-1.9697",
  "EmailSignatureEditor": "static-1.23927",
  "viral-links-lib": "static-1.6844",
  "data-token-picker": "static-1.16055",
  "FileManagerLib": "static-1.38553",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5053",
  "getting-started-shared-tasks-store": "static-1.17027",
  "campaign-roi-lib": "static-1.8299",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.199",
  "eligibility-engine-service-types": "static-1.3004",
  "crm_data": "static-4.91242",
  "crm-links": "static-1.6074",
  "customer-data-sidebar": "static-2.45441",
  "enrichment-properties-lib": "static-1.15060",
  "crm-fe-perf": "static-1.22714",
  "calling-global-api": "static-1.63698",
  "calling-internal-common": "static-1.31103",
  "calling-lifecycle-internal": "static-1.65080",
  "calling-lifecycle-messages": "static-1.57374",
  "commerce-products-lib": "static-1.8883",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.487",
  "inbounddb-objects-service-types": "static-1.4057",
  "meetings-icalendar-utils-lib": "static-1.442",
  "object-builder-ui-client": "static-1.48005",
  "pipeline-validation-client-types": "static-1.3794",
  "property-value-citations": "static-1.1436",
  "pulse": "static-1.321",
  "smart-property-lib": "static-1.5942",
  "tiered-pricing": "static-1.841",
  "ui-addon-form-validation": "static-1.10803",
  "growth-onboarding-next-action-components": "static-1.1340",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6392",
  "content-media-composition-data-lib": "static-1.11481",
  "content-media-compositions": "static-2.15488",
  "media-bridge-lib": "static-1.18578",
  "commerce-tours-lib": "static-1.5731",
  "growth-onboarding-reliability": "static-1.4895",
  "sales-checkout-service-client": "static-1.3477",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21319",
  "sales-email-signature-service-client": "static-1.3653",
  "audio-components": "static-1.5623",
  "FileManagerCore": "static-1.38412",
  "FileManagerImages": "static-1.36064",
  "video-components": "static-1.12595",
  "crm_universal": "static-1.21672",
  "customer-data-email": "static-1.17682",
  "calling-error-reporting": "static-1.31109",
  "card-payment-highlight-lib": "static-1.36526",
  "card-subscription-highlight-lib": "static-1.38882",
  "commerce-billing-lib": "static-1.18525",
  "commerce-contract-lib": "static-1.11228",
  "customer-data-content": "static-1.26884",
  "invoices-highlight-card-lib": "static-1.54055",
  "orders-highlight-card-lib": "static-1.20889",
  "products-highlight-card-lib": "static-1.17167",
  "project-storage": "static-1.4542",
  "quotes-highlight-card-lib": "static-1.71237",
  "breeze-intelligence-kit": "static-1.5331",
  "crm-source-interpretation-lib": "static-1.5138",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9577",
  "policy-lib": "static-1.6593",
  "shared-worker-versioning": "static-1.10847",
  "calling-usage-tracker": "static-1.6349",
  "voice-sms-access-library": "static-1.271",
  "commerce-permissions": "static-1.567",
  "products-iframe-lib": "static-1.7341",
  "products-ui-components-shared-msw-handlers": "static-1.9876",
  "directed-graph": "static-1.745",
  "event-emitter": "static-1.756",
  "react-tinymce": "static-1.54645",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9640",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53771",
  "tinymce-plugins": "static-1.56885",
  "tinymce-themes": "static-1.55741",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4341",
  "video-embed": "static-1.35084",
  "social-insights-client-types": "static-1.21368",
  "sequences-lib": "static-1.7702",
  "ui-gdpr-components": "static-1.10156",
  "commerce-shared-components-lib": "static-1.17937",
  "commerce-subscription-lib": "static-1.36459",
  "commerce-tools-ui-lib": "static-1.9814",
  "utility-belt": "static-1.2349",
  "payments-enrollment-embed-lib": "static-1.22057",
  "products-ui-components": "static-1.39402",
  "quotes-client-types": "static-1.37326",
  "quotes-ui-lib": "static-1.79957",
  "SalesContentIndexUI": "static-3.8914",
  "accounting-integrations-ui-components": "static-1.6737",
  "invoices-ui-lib": "static-1.54071",
  "commerce-products-api": "static-1.1968",
  "SafeStorage": "static-1.4213",
  "invoices-iframe-lib": "static-1.56129",
  "quotes-modal-lib": "static-1.101914",
  "calling-orchestration-schema": "static-1.35048",
  "sales-views-client-types": "static-1.4096",
  "hub-http-contrib": "static-1.2852",
  "interframe": "static-3.4599",
  "tinymce-data": "static-1.39856",
  "ui-addon-sales-email": "static-1.5022",
  "layout-dnd-components": "static-1.12048",
  "layout-dnd-utils": "static-1.11023",
  "ui-brand-identity-lib": "static-1.13916",
  "NamespacedHubStyle": "static-2.8904",
  "outpost": "static-1.4013",
  "sequences-client-types-lib": "static-1.7559",
  "customer-data-associations": "static-1.7147",
  "framework-data-table": "static-2.11433",
  "customer-data-rte": "static-1.32463",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5376",
  "InboxConnectUtils": "static-4.14246",
  "payments-post-enroll-local-storage-lib": "static-1.4920",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7145",
  "commerce-tax-lib": "static-1.326",
  "property-description-translator": "static-1.3667",
  "FireAlarmUi": "static-1.4337",
  "sales-templates-service-types-lib": "static-1.3999",
  "commerce-analytics-service-client": "static-1.3465",
  "totals-ui-components": "static-1.23021",
  "ContentData": "static-1.67721",
  "layout-data-lib": "static-1.9348",
  "deal-intel-decorators": "static-1.1284",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27732",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3645",
  "advanced-menus-core": "static-1.14826",
  "advanced-menus-lib": "static-1.11799",
  "ui-memberships-settings-lib": "static-1.33448",
  "deal-intel-utils": "static-1.1288",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14825",
  "simple-menus-lib": "static-1.16342"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11582",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "dashboard-client-types": "/dashboard-client-types/static-1.233",
  "data-fetching-client": "/data-fetching-client/static-1.9487",
  "foundations-components": "/foundations-components/static-1.7538",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.563",
  "foundations-theming": "/foundations-theming/static-1.4220",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7814",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9494",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11241",
  "I18n": "/I18n/static-7.1572",
  "jasmine-runner": "/jasmine-runner/static-1.6281",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11642",
  "quartz": "/quartz/static-1.6747",
  "react-dlb": "/react-dlb/static-1.72",
  "react-rhumb": "/react-rhumb/static-1.16459",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2670",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8493",
  "settings-ui-lib": "/settings-ui-lib/static-1.12331",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6747",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10948",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9355",
  "unified-auth": "/unified-auth/static-1.225",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.506",
  "usage-tracker": "/usage-tracker/static-1.7143",
  "usage-tracker-core": "/usage-tracker-core/static-1.6993",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7886",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6029",
  "integrations-lib": "/integrations-lib/static-1.15443",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18978",
  "property-management-iframe": "/property-management-iframe/static-1.12379",
  "quartz-config": "/quartz-config/static-1.525",
  "quartz-core": "/quartz-core/static-1.5966",
  "quartz-routing": "/quartz-routing/static-1.177",
  "quick-fetch": "/quick-fetch/static-1.3743",
  "react": "/react/static-7.179",
  "rpc-client-utils": "/rpc-client-utils/static-1.4443",
  "ts-schema": "/ts-schema/static-1.3912",
  "ui-universal-auth": "/ui-universal-auth/static-1.8711",
  "UIComponents": "/UIComponents/static-3.8188",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3237",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3024",
  "quartz-webpack": "/quartz-webpack/static-1.2971",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3807",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4645",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1936",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9236",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5181",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1226",
  "ui-fonts": "/ui-fonts/static-1.503",
  "ui-images": "/ui-images/static-2.1094",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2703",
  "foundations-theming-base": "/foundations-theming-base/static-1.3205",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.711",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2925",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4135",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8367",
  "ai-rendering-library": "/ai-rendering-library/static-1.9331",
  "chirp-fetch": "/chirp-fetch/static-1.1691",
  "connections-embed-lib": "/connections-embed-lib/static-1.645",
  "copilot-toolkit": "/copilot-toolkit/static-1.10554",
  "laboratory-lib": "/laboratory-lib/static-3.6969",
  "marketplace-embed": "/marketplace-embed/static-1.21509",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8874",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18934",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13149",
  "sanitize-text": "/sanitize-text/static-1.7949",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8505",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5557",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4829",
  "wootric-nps": "/wootric-nps/static-1.6792",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4458",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3963",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66560",
  "cssUtils": "/cssUtils/static-1.734",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11549",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10018",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10180",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7133",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17511",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4330",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5021",
  "quartz-i18n": "/quartz-i18n/static-1.422",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3539",
  "customer-data-objects": "/customer-data-objects/static-1.7458",
  "property-translator": "/property-translator/static-1.5221",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7733",
  "hs-promise-utils": "/hs-promise-utils/static-1.5402",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4690",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12858",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5397",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7597",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4283",
  "superstore": "/superstore/static-1.4579",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9955",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7466",
  "hub-http-janus": "/hub-http-janus/static-1.796",
  "hubspotter-http": "/hubspotter-http/static-1.4486",
  "immutable-less": "/immutable-less/static-1.4463",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16385",
  "nav-meta": "/nav-meta/static-1.28931",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10045",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17671",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3683",
  "property-management-common": "/property-management-common/static-1.4666",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8853",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.484",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.422",
  "quartz-head": "/quartz-head/static-1.412",
  "quartz-test": "/quartz-test/static-1.422",
  "quartz-tracking": "/quartz-tracking/static-1.126",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20355",
  "ContentUtils": "/ContentUtils/static-1.67646",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2295",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38936",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12816",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12954",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13573",
  "ExportDialog": "/ExportDialog/static-6.10195",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40678",
  "reporting-snowflake": "/reporting-snowflake/static-1.55178",
  "reporting-ui-components": "/reporting-ui-components/static-2.63831",
  "reporting-visualizations": "/reporting-visualizations/static-1.58636",
  "ui-addon-teams": "/ui-addon-teams/static-1.21254",
  "magpie-lib": "/magpie-lib/static-1.5402",
  "magpie-types": "/magpie-types/static-1.4862",
  "simple-logging-lib": "/simple-logging-lib/static-1.2859",
  "navigation-components": "/navigation-components/static-1.17294",
  "ai-studio-lib": "/ai-studio-lib/static-1.11024",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10287",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7798",
  "ui-tool-access": "/ui-tool-access/static-1.9953",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8023",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5560",
  "usage-tracker-public": "/usage-tracker-public/static-1.6954",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3425",
  "persist-promise": "/persist-promise/static-1.3517",
  "reference-resolvers": "/reference-resolvers/static-1.7969",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3753",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.149",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2808",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2210",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4878",
  "purchase-motions-components": "/purchase-motions-components/static-1.5494",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1360",
  "crm-component-utils": "/crm-component-utils/static-1.38503",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5681",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6682",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7903",
  "navigation-messaging": "/navigation-messaging/static-1.6621",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9492",
  "cms-field-types": "/cms-field-types/static-1.4615",
  "content-icons-ui": "/content-icons-ui/static-1.2156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7056",
  "crm-message-bus": "/crm-message-bus/static-1.42391",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21371",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9632",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4538",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3841",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6587",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.782",
  "onboarding-tours": "/onboarding-tours/static-1.16273",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13076",
  "academy-common-lib": "/academy-common-lib/static-1.13033",
  "content-assistance-lib": "/content-assistance-lib/static-1.7460",
  "dashboard-lib": "/dashboard-lib/static-1.80661",
  "file-manager-components": "/file-manager-components/static-1.22913",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17909",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17628",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17620",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19482",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8500",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4574",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10719",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8837",
  "user-context": "/user-context/static-1.4908",
  "growth-payments-core": "/growth-payments-core/static-1.24752",
  "reporting-plugins": "/reporting-plugins/static-1.9994",
  "reporting-reports": "/reporting-reports/static-1.66238",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.534",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28869",
  "react-codemirror": "/react-codemirror/static-1.10435",
  "apps-service-types": "/apps-service-types/static-1.3686",
  "oauth-service-types": "/oauth-service-types/static-1.4051",
  "onboarding-scopes": "/onboarding-scopes/static-1.6272",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4487",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7500",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14597",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8588",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4322",
  "nav-client-types": "/nav-client-types/static-1.2166",
  "purchase-motions-api": "/purchase-motions-api/static-1.5497",
  "signup-constants": "/signup-constants/static-1.18423",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3723",
  "card-properties-lib": "/card-properties-lib/static-1.43545",
  "crm-actions": "/crm-actions/static-1.6110",
  "crm-cards-data": "/crm-cards-data/static-1.1227",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42946",
  "customer-data-properties": "/customer-data-properties/static-1.50822",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8821",
  "customer-data-tracking": "/customer-data-tracking/static-1.6691",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3631",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3972",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3525",
  "external-options-client-types": "/external-options-client-types/static-1.3992",
  "react-dnd-compat": "/react-dnd-compat/static-1.4429",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5166",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2880",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1312",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.339",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7336",
  "academy-service-client": "/academy-service-client/static-1.3489",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27966",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8193",
  "video-components-external": "/video-components-external/static-1.10592",
  "video-data-lib": "/video-data-lib/static-1.34250",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8377",
  "payment-link-components": "/payment-link-components/static-1.22963",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9697",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23927",
  "viral-links-lib": "/viral-links-lib/static-1.6844",
  "data-token-picker": "/data-token-picker/static-1.16055",
  "FileManagerLib": "/FileManagerLib/static-1.38553",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5053",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17027",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8299",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.199",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3004",
  "crm_data": "/crm_data/static-4.91242",
  "crm-links": "/crm-links/static-1.6074",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45441",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15060",
  "crm-fe-perf": "/crm-fe-perf/static-1.22714",
  "calling-global-api": "/calling-global-api/static-1.63698",
  "calling-internal-common": "/calling-internal-common/static-1.31103",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65080",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57374",
  "commerce-products-lib": "/commerce-products-lib/static-1.8883",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.487",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4057",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.442",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48005",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3794",
  "property-value-citations": "/property-value-citations/static-1.1436",
  "pulse": "/pulse/static-1.321",
  "smart-property-lib": "/smart-property-lib/static-1.5942",
  "tiered-pricing": "/tiered-pricing/static-1.841",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10803",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1340",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6392",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11481",
  "content-media-compositions": "/content-media-compositions/static-2.15488",
  "media-bridge-lib": "/media-bridge-lib/static-1.18578",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5731",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4895",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3477",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21319",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3653",
  "audio-components": "/audio-components/static-1.5623",
  "FileManagerCore": "/FileManagerCore/static-1.38412",
  "FileManagerImages": "/FileManagerImages/static-1.36064",
  "video-components": "/video-components/static-1.12595",
  "crm_universal": "/crm_universal/static-1.21672",
  "customer-data-email": "/customer-data-email/static-1.17682",
  "calling-error-reporting": "/calling-error-reporting/static-1.31109",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36526",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38882",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18525",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11228",
  "customer-data-content": "/customer-data-content/static-1.26884",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54055",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20889",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17167",
  "project-storage": "/project-storage/static-1.4542",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71237",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5331",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5138",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9577",
  "policy-lib": "/policy-lib/static-1.6593",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10847",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6349",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.271",
  "commerce-permissions": "/commerce-permissions/static-1.567",
  "products-iframe-lib": "/products-iframe-lib/static-1.7341",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9876",
  "directed-graph": "/directed-graph/static-1.745",
  "event-emitter": "/event-emitter/static-1.756",
  "react-tinymce": "/react-tinymce/static-1.54645",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9640",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53771",
  "tinymce-plugins": "/tinymce-plugins/static-1.56885",
  "tinymce-themes": "/tinymce-themes/static-1.55741",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4341",
  "video-embed": "/video-embed/static-1.35084",
  "social-insights-client-types": "/social-insights-client-types/static-1.21368",
  "sequences-lib": "/sequences-lib/static-1.7702",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10156",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17937",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36459",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9814",
  "utility-belt": "/utility-belt/static-1.2349",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22057",
  "products-ui-components": "/products-ui-components/static-1.39402",
  "quotes-client-types": "/quotes-client-types/static-1.37326",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79957",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8914",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6737",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54071",
  "commerce-products-api": "/commerce-products-api/static-1.1968",
  "SafeStorage": "/SafeStorage/static-1.4213",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56129",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101914",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35048",
  "sales-views-client-types": "/sales-views-client-types/static-1.4096",
  "hub-http-contrib": "/hub-http-contrib/static-1.2852",
  "interframe": "/interframe/static-3.4599",
  "tinymce-data": "/tinymce-data/static-1.39856",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5022",
  "layout-dnd-components": "/layout-dnd-components/static-1.12048",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11023",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13916",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8904",
  "outpost": "/outpost/static-1.4013",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7559",
  "customer-data-associations": "/customer-data-associations/static-1.7147",
  "framework-data-table": "/framework-data-table/static-2.11433",
  "customer-data-rte": "/customer-data-rte/static-1.32463",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5376",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14246",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4920",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7145",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.326",
  "property-description-translator": "/property-description-translator/static-1.3667",
  "FireAlarmUi": "/FireAlarmUi/static-1.4337",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3999",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3465",
  "totals-ui-components": "/totals-ui-components/static-1.23021",
  "ContentData": "/ContentData/static-1.67721",
  "layout-data-lib": "/layout-data-lib/static-1.9348",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1284",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27732",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3645",
  "advanced-menus-core": "/advanced-menus-core/static-1.14826",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11799",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33448",
  "deal-intel-utils": "/deal-intel-utils/static-1.1288",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14825",
  "simple-menus-lib": "/simple-menus-lib/static-1.16342"
}
};
